export const selectAppInfo = state => state.root.appInfo
export const selectRouterPath = state => state.router.location.pathname


// WEBPACK FOOTER //
// ./src/services/selectors/index.js